export default {
  bidders: {
    max: {}
  }
}
